<template>
  <FreeGallery is-autoplay :is-buttons="false" is-loop>
    <slot />
  </FreeGallery>
</template>
